/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {EventListExportRequest} from "../model/event-list-export-request";
import {ExportAssessmentsByIdsRequest} from "../model/export-assessments-by-ids-request";
import {ExportCancelRequest} from "../model/export-cancel-request";
import {ExportDeleteRequest} from "../model/export-delete-request";
import {ExportDismissRequest} from "../model/export-dismiss-request";
import {ExportEventRequest} from "../model/export-event-request";
import {ExportPauseRequest} from "../model/export-pause-request";
import {ExportProcessInfo} from "../model/export-process-info";
import {ExportResponse} from "../model/export-response";
import {ExportResumeRequest} from "../model/export-resume-request";
import {GetCurrentExportsInternalResponse} from "../model/get-current-exports-internal-response";
import {RecordingExportRequest} from "../model/recording-export-request";
import {RecordingListExportRequest} from "../model/recording-list-export-request";

@Injectable({
    providedIn: "root",
})
export class SimExportService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public cancel(request: ExportCancelRequest) {
        return super.post<void>(`/api/Export/Cancel`, request);
    }

    public deleteExport(request: ExportDeleteRequest) {
        return super.post<boolean>(`/api/Export/DeleteExport`, request);
    }

    public dismiss(request: ExportDismissRequest) {
        return super.post<void>(`/api/Export/Dismiss`, request);
    }

    public downloadExport_Url(exportProcessInfoId: string) {
        return super.getUrl(`/api/Export/DownloadExport`, {exportProcessInfoId: exportProcessInfoId});
    }

    public export(request: RecordingExportRequest) {
        return super.post<ExportResponse>(`/api/Export/Export`, request);
    }

    public exportAssessmentsById(request: ExportAssessmentsByIdsRequest) {
        return super.post<ExportResponse[]>(`/api/Export/ExportAssessmentsById`, request);
    }

    public exportByList(request: RecordingListExportRequest) {
        return super.post<ExportResponse[]>(`/api/Export/ExportByList`, request);
    }

    public exportEvent(request: ExportEventRequest) {
        return super.post<ExportResponse[]>(`/api/Export/ExportEvent`, request);
    }

    public exportEventsByList(request: EventListExportRequest) {
        return super.post<ExportResponse[]>(`/api/Export/ExportEventsByList`, request);
    }

    public getCurrentAssessmentsExports(assessmentIds: string[], last: number = 2147483647, excludeIdle: boolean = false) {
        return super.get<GetCurrentExportsInternalResponse>(`/api/Export/GetCurrentAssessmentsExports`, {assessmentIds: assessmentIds, last: last, excludeIdle: excludeIdle});
    }

    public getCurrentEventExports(eventId: string = null, last: number = 2147483647, excludeIdle: boolean = false) {
        return super.get<GetCurrentExportsInternalResponse>(`/api/Export/GetCurrentEventExports`, {eventId: eventId, last: last, excludeIdle: excludeIdle});
    }

    public getCurrentEventListExports(eventIds: string[] = null, last: number = 2147483647, excludeIdle: boolean = false) {
        return super.get<GetCurrentExportsInternalResponse>(`/api/Export/GetCurrentEventListExports`, {eventIds: eventIds, last: last, excludeIdle: excludeIdle});
    }

    public getCurrentExports(scenarioRecordingId: string = null, last: number = 2147483647, excludeIdle: boolean = false) {
        return super.get<GetCurrentExportsInternalResponse>(`/api/Export/GetCurrentExports`, {scenarioRecordingId: scenarioRecordingId, last: last, excludeIdle: excludeIdle});
    }

    public getCurrentExportsByList(scenarioRecordingIds: string[] = null, last: number = 2147483647, excludeIdle: boolean = false) {
        return super.get<GetCurrentExportsInternalResponse>(`/api/Export/GetCurrentExportsByList`, {scenarioRecordingIds: scenarioRecordingIds, last: last, excludeIdle: excludeIdle});
    }

    public getCurrentExportsForDisplay(scenarioRecordingId: string = null, last: number = 2147483647) {
        return super.get<GetCurrentExportsInternalResponse>(`/api/Export/GetCurrentExportsForDisplay`, {scenarioRecordingId: scenarioRecordingId, last: last});
    }

    public getExport(exportProcessInfoId: string) {
        return super.get<ExportProcessInfo>(`/api/Export/GetExport`, {exportProcessInfoId: exportProcessInfoId});
    }

    public getNoVideoPng_Url() {
        return super.getUrl(`/api/Export/GetNoVideoPng`, );
    }

    public pause(request: ExportPauseRequest) {
        return super.post<void>(`/api/Export/Pause`, request);
    }

    public resume(request: ExportResumeRequest) {
        return super.post<void>(`/api/Export/Resume`, request);
    }
}